import React from 'react';
import type { TApiApplication } from '~/modules/covenants/types.ts';
import { StatusFilterValue } from '~/modules/covenants/types.ts';
import { StatusChipWithTooltip } from '~/modules/covenants/components/StatusChipWithTooltip.tsx';
import { getManagerAppStatusConfig } from '~/modules/covenants/statusConfig.ts';
import { commonStyles } from '~/modules/covenants/CovenantsDataForm/commonStyles.ts';
import { managerComponentStyles } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/components/styles.ts';
import { tableRowStyles } from '~/modules/covenants/utils.ts';

interface IManagerStatusChipProps {
  status: TApiApplication['status'];
}

export const StatusChip: React.FC<IManagerStatusChipProps> = ({ status }) => {
  const { label, color, description } = getManagerAppStatusConfig(status);

  return (
    <StatusChipWithTooltip
      label={label}
      color={color}
      description={description}
      chipSx={(theme) => ({
        ...tableRowStyles(commonStyles.statusChip, theme),
        ...(status === StatusFilterValue.Sent
          ? tableRowStyles(managerComponentStyles.sentChip, theme)
          : {}),
      })}
    />
  );
};

